import * as React from 'react'

import { DaysPerWeekIcon, Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-DAYS-PER-WEEK`

interface IProps {
  daysPerWeek: number[]
}

export default function DaysPerWeek(props: IProps) {
  const { daysPerWeek } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (!daysPerWeek.length) return null

  const sorted = daysPerWeek.concat().sort()
  const first = sorted.slice(0, daysPerWeek.length - 1)
  const last = sorted[daysPerWeek.length - 1]
  const formattedDays = [first.join(', '), last].filter(Boolean).join(' and ')

  return (
    <Bullet icon={<DaysPerWeekIcon />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{`${formattedDays} ${daysPerWeek.length > 1 ? 'days' : 'day'} per week`}</Text>
    </Bullet>
  )
}
